import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RepositoryService } from 'src/app/services/repository.service';

@Component({
  selector: 'app-podrobno-server',
  templateUrl: './podrobno-server.component.html',
  styleUrls: ['./podrobno-server.component.css']
})
export class PodrobnoServerComponent implements OnInit {

  public returnedQueryParams = [];
  public dataSourceServers: Array<any> = [];
  public columnsServers = [];
  public spinner = false;
  constructor(private repositoryService: RepositoryService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.returnedQueryParams.push(params['modulId']);
      this.returnedQueryParams.push(params['companyId']);
    });
  }

  ngOnInit() {
    this.spinner = true;
    this.repositoryService.getServers(this.returnedQueryParams[0], this.returnedQueryParams[1]).subscribe( data => {
      this.dataSourceServers = data.data.servers;
      if(this.dataSourceServers.length > 0) {
        Object.keys(this.dataSourceServers[0]).forEach(key => {
          this.columnsServers.push(key);
        });
        this.columnsServers.push('Klient url');
        this.columnsServers.push('Glassfish url');
      }
      this.spinner = false;
    }, error => {
      console.log(error);
    });


  }

}
